import { ItemView } from '@glu/core';
import template from './filterBadgeHeader.hbs';

export default ItemView.extend({
  template,
  tagName: 'span',

  className: 'label label-filter',

  events: {
    'click .remove-filter': 'handleRemove',
    click: 'reopenFilter'
  },

  modelEvents: {
    change: 'render'
  },

  handleRemove(e) {
    e.preventDefault();
    e.stopPropagation();

    this.options.masterCollection.trigger(`grid:clear:filter:${this.model.get('field')}`, this);

    return this.model.destroy();
  },

  reopenFilter() {
    this.options.filters.trigger('grid:reopen:filter', this.model);
  }
});
